import React, { useState, useEffect } from "react";
import Card from "../../Components/Card/Card";
import { fetchAllWorkOrders, fetchEmployees } from "../../Utils/api";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import SortIcon from '@mui/icons-material/Sort';
import "../../Pages/workord-tab/workorderpage.css";
import { useAuth } from "../../Auth/AuthContext";

const WorkOrdersPopup = ({ customerId, open, onClose }) => {
    const [workOrders, setWorkOrders] = useState([]);
    const [sortOrder, setSortOrder] = useState("desc");
    const { companyId } = useAuth(); 

    const formatDate = (dateString) => {
        if (!dateString) return 'No date set';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    };

    const fetchCustomerWorkOrders = async () => {
        try {
            const response = await fetchAllWorkOrders(companyId);
            if (Array.isArray(response)) {
                const technicianList = await fetchEmployees(companyId, null, "Technician");

                // First filter by customerId
                let customerWorkOrders = response.filter(
                    item => item.customer.customerId === customerId
                );

                // Hardcoded status filter - only show "Scheduled" work orders
                customerWorkOrders = customerWorkOrders.filter(
                    item => item.workOrder.statusCode === "Completed"
                );

                const formattedWorkOrders = customerWorkOrders.map((item) => ({
                    customerName: `${item.customer.custFirstName} ${item.customer.custLastName}`,
                    address: `${item.customer.custAddress}, ${item.customer.custCity}, ${item.customer.custState} ${item.customer.custZip}`,
                    assigneeName: `${item.employee.firstName} ${item.employee.lastName}`,
                    assignee: item.employee,
                    status: item.workOrder.statusCode,
                    workOrder: item.workOrder,
                    workOrderDate: item.workOrder.initialServiceDate,
                    workOrderType: item.workOrder.workOrderType,
                    workOrderComment: item.workOrder.workOrderComment,
                    employeeId: item.employee.employeeId,
                    customerId: item.customer.customerId,
                    employeeList: technicianList,
                }));

                setWorkOrders(formattedWorkOrders);
            } else {
                setWorkOrders([]);
            }
        } catch (error) {
            console.error("Failed to load customer work orders", error);
            setWorkOrders([]);
        }
    };

    useEffect(() => {
        if (open && customerId) {
            fetchCustomerWorkOrders();
        }
    }, [open, customerId]);

    const displayedWorkOrders = [...workOrders].sort((a, b) => {
        const dateA = new Date(a.workOrderDate);
        const dateB = new Date(b.workOrderDate);
        return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });

    return (
        <Modal open={open} onClose={onClose}>
            <Box className="work-orders-popup-container">
                <div className="work-orders-popup-content">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <h2>Completed Work Orders</h2> {/* Updated title to reflect filtered status */}
                        <button
                            onClick={() => setSortOrder(prev => prev === "asc" ? "desc" : "asc")}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: '#1d5ca7',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <SortIcon
                                style={{
                                    transform: sortOrder === "asc" ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: 'transform 0.3s ease'
                                }}
                            />
                            {sortOrder === "asc" ? "Oldest First" : "Newest First"}
                        </button>
                    </div>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))',
                        gap: '20px',
                        maxHeight: '70vh',
                        overflowY: 'auto',
                        padding: '10px'
                    }}>
                        {displayedWorkOrders.length > 0 ? (
                            displayedWorkOrders.map((workOrder, index) => (
                                <Card
                                    key={index}
                                    customerName={workOrder.customerName}
                                    address={workOrder.address}
                                    assignee={workOrder.assigneeName}
                                    status={workOrder.status}
                                    date={formatDate(workOrder.workOrderDate)}
                                    style={{
                                        minHeight: '200px',
                                        width: '100%',
                                        boxSizing: 'border-box'
                                    }}
                                    hideButtons={true}
                                />
                            ))
                        ) : (
                            <p>No work orders found for this customer.</p>
                        )}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                        <button
                            onClick={onClose}
                            style={{
                                padding: '8px 16px',
                                borderRadius: '5px',
                                backgroundColor: '#1d5ca7',
                                color: '#fff',
                                border: 'none',
                                cursor: 'pointer',
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default WorkOrdersPopup;